module.exports = __webpack_public_path__ + "media/images/delivery-truck-d3546f64bc3abe208700f74ce9c008db.png";